import { render } from "./NewPatientCase.vue?vue&type=template&id=020b811b"
import script from "./NewPatientCase.vue?vue&type=script&lang=js"
export * from "./NewPatientCase.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/NewPatientCase.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "020b811b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('020b811b', __exports__)) {
    console.log('reload')
    api.reload('020b811b', __exports__)
  }
  
  module.hot.accept("./NewPatientCase.vue?vue&type=template&id=020b811b", () => {
    console.log('re-render')
    api.rerender('020b811b', render)
  })

}


export default __exports__